import React from 'react';
import { Box } from '@mui/material';

import {
  BoolField,
  BoolAllField,
  ChoiceField,
  DateField,
  DateTimeField,
  MultiChoiceField,
  CharField,
  TimeField,
  NumberField,
  RadioChoiceField,
  OnChangeCharField,
  InfoField,
  InfoClearField,
  ButtonField,
  MultiCharField,
  MultiCharWithChoiceField,
  DiscountSpecialField,
  OLDiscountSpecialField,
  PhoneNumberField,
  SubmitCharField
} from '../dynamic-fields';

import OrderCalculator from './OrderCalculator';
import CustomCalculator from './CustomCalculator';
import { getOrderPrice, getWROrderPrice, getZSOrderPrice } from '../../services/request';

export const FormFieldPanel = props => {
  const { field, formIdentifier } = props;

  /**
   * Mapowanie typów pól na komponenty dynamiczne.
   * Dodanie nowego typu = jedna linijka w tym obiekcie.
   */
  const fieldComponents = {
    char: field.on_change ? OnChangeCharField : CharField,
    text: CharField,
    bool: BoolField,
    choice: ChoiceField,
    multichoice: MultiChoiceField,
    radiochoice: RadioChoiceField,
    date: DateField,
    time: TimeField,
    datetime: DateTimeField,
    number: NumberField,
    phonenumber: PhoneNumberField,
    button: ButtonField,
    info: InfoField,
    infoclear: InfoClearField,
    multichar: MultiCharField,
    multicharwithchoice: MultiCharWithChoiceField,
    boolAll: BoolAllField,
    submitchar: SubmitCharField
  };

  // Specjalne przypadki wymagające własnej logiki renderowania
  const renderSpecialCases = () => {
    // promocje ZS
    if (field.name === 'discount') {
      return <DiscountSpecialField {...props} />;
    }

    // promocje OL / WR
    if (field.name === 'ol_discounts') {
      return <OLDiscountSpecialField {...props} />;
    }

    // kalkulatory
    if (field.type === 'calculator') {
      if (['free_guardians_value_calculator', 'free_guardians_exceeded_calculator'].includes(field.name)) {
        return <CustomCalculator {...props} />;
      }

      const calculatorProps = {
        ...props,
        requestMethod:
          formIdentifier === 'wyjazdy_rodzinne'
            ? getWROrderPrice
            : formIdentifier === 'zielone_szkoly'
              ? getZSOrderPrice
              : getOrderPrice
      };

      return <OrderCalculator {...calculatorProps} />;
    }

    return null;
  };


  // Główna logika renderowania:
  // 1. najpierw przypadki specjalne,
  // 2. potem standardowe pola z mapy.

  const renderField = () => {
    const special = renderSpecialCases();
    if (special) {
      return special;
    }

    const FieldComponent = fieldComponents[field.type];
    if (!FieldComponent) {
      return null;
    }
    if (field.type == 'info' || field.type == 'infoclear') {
      return <FieldComponent {...props} info={props.field} />;
    }

    // przekazujemy wszystkie propsy + ewentualne drobne nadpisania
    return <FieldComponent {...props} />;

  };

  return <Box>{renderField()}</Box>;
};
